import { applyMiddleware, createStore } from 'redux'
import thunk from 'redux-thunk'
import Api from '../../api'
import reducer from './reducer'

// create a makeStore function
export default createStore(
  reducer,
  applyMiddleware(
    thunk.withExtraArgument({
      Api,
    }),
  ),
)

// export an assembled wrapper
// export const wrapper = createWrapper(makeStore, { debug: false })
